// 去掉空格
const checkBlank = (rules, val, callback, prop, _this,formName) => {
    _this.$set(_this[formName]||_this.form, prop, val.replace(/\s+/g, ""));
    callback();
};
export default {
    checkBlank
}